import {Container} from "./Container"

export const ForgotPassFormStyles = {
    Container
}